/* GlueErrorCode.js */

"use strict";
class GlueErrorCode extends Error {
    constructor(errorObj) {
        super();
        Object.keys(errorObj||{}).forEach((propName)=>{
            let prop = errorObj[propName];
            switch(propName){
                case 'errorMsg'://jshint ignore:line
                case 'ErrorMsg'://jshint ignore:line
                    this.errorMsg = errorObj.errorMsg || errorObj.ErrorMsg;
                    break;
                case 'errorCode'://jshint ignore:line
                case 'ErrorCode'://jshint ignore:line
                    this.errorCode = errorObj.errorCode || errorObj.ErrorCode;
                    break;
                default:
                    this[propName] = prop;
                    break;
            }
        });
        this.message = this.errorMsg;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = (new Error(this.message)).stack;
        }
    }
}
module.exports=GlueErrorCode;